import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ProcessService } from 'src/app/services/process.service';
import { ActivatedRoute } from '@angular/router';
import { FarmService } from 'src/app/services/farm-service.service';
declare var $: any;
import Swal from 'sweetalert2';
@Component({
  selector: 'smart-config-history',
  templateUrl: './config-history.component.html',
  styleUrls: ['./config-history.component.scss']
})
export class ConfigHistoryComponent implements OnInit {
  
  constructor(   
  ) {}

  ngOnInit(): void {
  }

  
}
